import React from 'react';

interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  sizePx?: number;
}

export const CloseButton: React.FC<CloseButtonProps> = ({
  onClick,
  ariaLabel = 'Close',
  sizePx = 28,
}) => {
  return (
    <button
      type="button"
      className="font-mono"
      aria-label={ariaLabel}
      onClick={onClick}
      style={{
        width: sizePx,
        height: sizePx,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        border: '1px solid #f85149',
        borderRadius: 0,
        color: '#f85149',
        cursor: 'pointer',
        fontSize: Math.max(14, Math.floor(sizePx * 0.6)),
        fontWeight: 700,
        lineHeight: 1,
        padding: 0,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#21262d';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
      }}
    >
      X
    </button>
  );
};
